// Phase 4: Simple performance monitoring
// Logs slow database queries to console in development.
// TypeScript source — perf.js is a thin re-export stub for existing `.js`
// import paths.

import { logger } from "./logger";

var SLOW_THRESHOLD = 500; // ms — warn if query takes longer than this

export function timedQuery<T>(label: string, queryPromise: Promise<T>): Promise<T> {
  var start = Date.now();
  return queryPromise.then(function (result) {
    var elapsed = Date.now() - start;
    if (elapsed > SLOW_THRESHOLD) {
      logger.warn(`[SLOW QUERY] ${label}: ${elapsed}ms`);
    }
    return result;
  });
}

// Track page load performance
export function logPageLoad(): void {
  if (typeof window === "undefined" || !window.performance) return;
  window.addEventListener("load", function () {
    setTimeout(function () {
      var nav = performance.getEntriesByType("navigation")[0] as
        | PerformanceNavigationTiming
        | undefined;
      if (nav) {
        logger.debug(`[Perf] DOM ready: ${Math.round(nav.domContentLoadedEventEnd)}ms`);
        logger.debug(`[Perf] Page load: ${Math.round(nav.loadEventEnd)}ms`);
      }
      var resources = performance.getEntriesByType("resource") as PerformanceResourceTiming[];
      var jsFiles = resources.filter(function (r) {
        return r.name.endsWith(".js");
      });
      var totalJS = jsFiles.reduce(function (sum, r) {
        return sum + r.transferSize;
      }, 0);
      logger.debug(
        "[Perf] JS bundle total: " +
          Math.round(totalJS / 1024) +
          "KB across " +
          jsFiles.length +
          " files"
      );
    }, 100);
  });
}
